module.exports = __webpack_public_path__ + "media/images/gift/gift-intro-image-ece50bc8bcdb9aea34ba53c95bd09786.png";